<template>
    <div class="roles content-container flex-column">
      <div class="content-wrap">
        <!-- Górny panel z menu i tłem po lewej -->
        <div class="d-flex roles-section-container no-content">
          <div class="roles-section"></div>
          <div class="content-wrap">
            <TopMenu />
          </div>
        </div>
  
        <!-- Widok dodawania nowej roli -->
        <div v-if="showAddRole" @cancel="showAddRole = false" class="d-flex roles-section-container">
          <div class="roles-section">
            <span>
              {{ t('add-role') }}
            </span>
          </div>
          <div class="content-wrap">
            <div class="collapse show" id="addRole">
              <!-- Komponent do dodawania roli.
                   Nasłuchuje eventów: zamknięcie widoku lub dodanie roli -->
              <AddRole @role-added="handleRoleAdded" @cancel-add-role="showAddRole = false" />
            </div>
          </div>
        </div>
  
        <!-- Widok listy ról (główna lista, jeśli nie dodajemy) -->
        <div v-else class="d-flex roles-section-container">
        <!-- <div class="d-flex roles-section-container"> -->
          <div class="roles-section">
            <span v-if="!isEditMode">
              {{ t('role-list') }}
            </span>

            <span v-else>
              {{ t('role-edit') }}
            </span>
          </div>
          <div class="content-wrap">
            <!-- Pasek nagłówka listy ról + wyszukiwarka + przycisk dodawania -->
            <div v-if="!isEditMode" class="d-flex align-items-center justify-content-between role-list-header">
              <h3>{{ t('role-list').toUpperCase() }}</h3>
              <div class="search-bar">
                <!-- Przycisk + do wyświetlenia formularza dodawania roli -->
                <span @click="toggleAddRole" class="add-role-action">+</span>
                <!-- Wyszukiwarka po rolachch -->
                <!-- <input
                  type="text"
                  v-model="searchQuery"
                  :placeholder="t('search-role')"
                /> -->
              </div>
            </div>
            <!-- Lista ról (przekazuje searchQuery do filtrowania) -->
            <div class="collapse show" id="roleList">
              <!-- <RoleList 
                :search-query="searchQuery" 
                @clearSearch="searchQuery = ''"
                @editMode="isEditMode = $event"
                :key="roleListKey"
              /> -->
              <!-- <RoleList /> -->
              <RoleList 
                @editMode="isEditMode = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
  import RoleList from "@/components/RoleList.vue";
  import TopMenu from "../components/TopMenu.vue";
  import AddRole from "@/components/AddRole";
  // import Roles from "@/services/Roles";
  // import moment from "moment";
  
  export default {
    name: "HomeView",
    components: {
      // RoleList,
      RoleList,
      TopMenu,
      AddRole,
    },
    data() {
      return {
        isDownloading: false, // status pobierania pliku
        searchQuery: '',      // fraza wyszukiwania roli
        roleListKey: 0,       // klucz do wymuszenia reloadu listy ról
        showAddRole: false,   // czy widok dodawania roli jest widoczny
        isEditMode: false,    // czy edytujemy konkretną rolę (RoleList ustawia ten tryb)
      };
    },
    methods: {
      // Przełącza formularz dodawania roli
      toggleAddRole() {
        this.showAddRole = !this.showAddRole;
      },
      // Pobranie logów ról do ZIP-a (ostatnie 7 dni)
      // retrieveZip() {
      //   this.isDownloading = true;
      //   const dateFrom = moment().subtract(7, "days").toISOString(false);
      //   const dateTo = moment().toISOString(false);
      //   Roles.getZip(dateFrom, dateTo)
      //     .then((data) => {
      //       Roles.fetch(data.link)
      //         .then((response) => {
      //           const link = document.createElement("a");
      //           link.href = URL.createObjectURL(response);
      //           link.download = "role_logs";
      //           link.click();
      //           this.isDownloading = false;
      //           URL.revokeObjectURL(link.href);
      //         })
      //         .catch(console.error);
      //     })
      //     .catch((error) => {
      //       this.loading = false;
      //       console.error(error);
      //     });
      // },
      // Po dodaniu roli ukrywa formularz i odświeża listę ról
      handleRoleAdded() {
        this.showAddRole = false;
        this.roleListKey++;
      }
    },
  };
</script>
  
<style scoped>
  .roles-section-container {
    width: 100%;
  }
  
  .role-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 5px;          /* przeniesiony padding z h3 */
    background-color: white;
    border-bottom: 1px solid #ccc;
  }

  .role-list-header h3 {
    margin: 0;
    padding: 0;                  /* ważne */
    line-height: 1.2;
  }

  /* sam pasek akcji (szukajka/plus) też flex -> idealne centrowanie */
  .search-bar {
    display: flex;
    align-items: center;
    gap: 12px;                   /* odstęp na przyszły input/ikonki */
  }

  /* plus jako kwadratowy przycisk, bez 'top: 3px' */
  .add-role-action {
    position: static;            /* usuń przesunięcie */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    margin-right: 0;             /* nie musi być potrzebny */
    border-radius: 8px;          /* opcjonalnie */
  }

  .search-bar input {
    margin-right: 1rem;
    margin-bottom: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .roles-section {
    width: 365px;
    background: url("../assets/l-filter-bg.png") repeat-y right;
  }
  
  .roles-section > span {
    padding: 10px 25px;
    position: relative;
    display: block;
  }
  
  .icon-collapse {
    background: url("../assets/icons/zwin.png") no-repeat left top;
    width: 19px;
    height: 19px;
    position: absolute;
    cursor: pointer;
    right: 10px;
  }
  
  .collapsed.icon-collapse {
    background: url("../assets/icons/rozwin.png") no-repeat left top;
  }
  
  .content-wrap h3 {
    padding: 15px 25px;
    background-color: white;
  }
</style>
  